import React from "react";
import { CreateNFeContext } from "../../../Context";
import Button from "../../../../../../../_components/Button";
export default (props) => {
  const context = React.useContext(CreateNFeContext);

  function onClick(e) {
    context.handlers.stepMove(e);
  }

  if (context.step === "nfe-details") {
    return (
      <div className="row">
        <div className="col-12 ">
          <div className="d-flex justify-content-end">
            <Button data-cy-test="#nfe-issuer-button-next-step" data-move-to="next-step" onClick={onClick}>
              Avançar <i className="ml-2 fas fa-arrow-right" />
            </Button>
          </div>
        </div>
      </div>
    );
  } else if (context.step === "finish") {
    return (
      <div className="row">
        <div className="col-md-6">
          <Button disabled={context.sending} data-move-to="pevious-step" onClick={onClick}>
            <i className="fa fa-arrow-left mr-2" />
            Anterior
          </Button>
        </div>
        <div className="col-md-6">
          <div className="d-flex justify-content-between">
            <Button disabled={context.sending} loading={context.sending} data-cy-test="#nfe-issuer-button-get-preview-nfe" onClick={() => context.handlers.sendNFe(true)}>
              Pré-Visualização Da DANFE{" "}
              <i className="fas fa-file-invoice ml-2" />
            </Button>
            <Button disabled={context.sending} loading={context.sending} data-cy-test="#nfe-issuer-button-send-nfe" onClick={context.handlers.sendNFe}>
              Emitir NF-e <i className="fas fa-file-alt ml-2" />
            </Button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between">
            <Button data-move-to="pevious-step" onClick={onClick}>
              <i className="fa fa-arrow-left mr-2" />
              Anterior
            </Button>
            <Button data-cy-test="#nfe-issuer-button-next-step" data-move-to="next-step" onClick={onClick}>
              Avançar <i className="ml-2 fas fa-arrow-right" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/components/Steps/Footer/index.jsx